import { default as dayjs } from "dayjs";

const DATE_FORMAT = "MMM DD, YYYY HH:mm:ss";

export function formatEpoch(epochDate: number | undefined): string {
  if (epochDate === undefined) {
    return "";
  }
  return dayjs.unix(epochDate).format(DATE_FORMAT);
}

export function formatDate(date: Date | string | undefined): string {
  if (!date) {
    return "";
  }
  return dayjs(date).format(DATE_FORMAT);
}

/**
 * Converts a Date to Unix epoch time.
 * @param date
 */
export function dateToEpoch(date: Date): number {
  return Math.floor(date.getTime() / 1000);
}

/**
 * Converts Unix epoch time to Date
 * @param epochTime
 */
export function epochToDate(epochTime: number): Date {
  return new Date(epochTime * 1000);
}

/**
 * Converts a duration from seconds into a formatted string 'HH:mm:ss'.
 *
 * @param {number} seconds - The total number of seconds to format.
 * @returns {string} A string representing the duration in 'HH:mm:ss' format.
 */
export function formatDuration(seconds: number): string {
  seconds = Math.round(seconds);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

/**
 * Converts seconds to minutes, rounding up to the nearest minute.
 * @param seconds - The number of seconds to convert
 * @returns The number of minutes (rounded up)
 */
export function secondsToMinutes(seconds: number): number {
  return Math.ceil(seconds / 60);
}
